
export default {
  fetching: false
}



// WEBPACK FOOTER //
// ./src/store/state.js